import { TFunction } from 'react-i18next';
import {
  AuthorizationMethod,
  PriceType,
  TariffComponent,
} from 'subdomains/cpo/types/charging-policy';

export function getAuthorizationMethodLabel(
  t: TFunction<'translation', undefined>,
  authorizationMethod: AuthorizationMethod
): string {
  switch (authorizationMethod) {
    case AuthorizationMethod.CHARGE_CARD:
      return t(
        'providerAdmin.chargingPolicyForm.tariffRulePreview.authorizationMethodChargeCardOption',
        'Charge Card'
      );
    case AuthorizationMethod.SCAN_TO_PAY:
      return t(
        'providerAdmin.chargingPolicyForm.tariffRulePreview.authorizationMethodScanToPayOption',
        'Scan to Pay'
      );
    case AuthorizationMethod.TAP_TO_PAY:
      return t(
        'providerAdmin.chargingPolicyForm.tariffRulePreview.authorizationMethodTapToPayOption',
        'Tap to Pay'
      );
    default:
      return '';
  }
}

export function tariffComponentKey(component: TariffComponent) {
  switch (component.price?.type) {
    case PriceType.FLAT:
    case PriceType.TIME:
    case PriceType.ENERGY:
    case PriceType.PARKING_TIME:
      return `${component.__id}-${component.price?.type}-${component.price?.value}`;
  }
}
